import Vue from "vue";
import VueI18n from "vue-i18n";
import SuiVue from "semantic-ui-vue";
import App from "./App.vue";
import "@/semantic/dist/semantic.min.css";
import cs from "./assets/i18n/cs.json";
import en from "./assets/i18n/en.json";

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(SuiVue);

const i18n = new VueI18n({
  locale: navigator.language.split("-")[0],
  messages: {
    cs,
    en
  }
});

new Vue({
  i18n,
  render: h => h(App)
}).$mount("#app");
